import { render, staticRenderFns } from "./DiagnosisInterface.vue?vue&type=template&id=0890a66e&scoped=true"
import script from "./DiagnosisInterface.vue?vue&type=script&lang=js"
export * from "./DiagnosisInterface.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisInterface.vue?vue&type=style&index=0&id=0890a66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890a66e",
  null
  
)

export default component.exports